'use strict';

jQuery($ => {
    $('.gecko-builder-content-slider').each((i, ui) => {
        // Create a swiper element for each section
        const swiper = new Swiper(ui, {
            loop: true,
            // shortSwipes: false,
            threshold: 20,
            // autoHeight: true,
            navigation: {
                prevEl: '.gecko-builder-content-slider__nav-button--prev',
                nextEl: '.gecko-builder-content-slider__nav-button--next',
            },

            on: {
                init: function() {
                    const slide = this.slides[this.activeIndex];

                    if ($(slide).hasClass('gecko-builder-content-slider__slide--light')) {
                        $(ui).removeClass('text-style--dark').addClass('text-style--light');
                    } else {
                        $(ui).removeClass('text-style--light').addClass('text-style--dark');
                    }
                },
                slideChange: function() {
                    const slide = this.slides[this.activeIndex];

                    if ($(slide).hasClass('gecko-builder-content-slider__slide--light')) {
                        $(ui).removeClass('text-style--dark').addClass('text-style--light');
                    } else {
                        $(ui).removeClass('text-style--light').addClass('text-style--dark');
                    }
                }
            }
        });
    });
});
